<template>
    <div v-if="visible" class="fixed top-5 right-5 max-w-sm w-full bg-gray-800 text-white p-4 rounded-lg shadow-lg" :class="toastTypeClasses">
      <div class="flex items-center justify-between">
        <div>
          <p class="font-medium">{{ message }}</p>
        </div>
        <button @click="closeToast" class="ml-3 text-xl font-bold text-white">
          &times;
        </button>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'ToastCreation',
    props: {
      message: {
        type: String,
        required: true
      },
      type: {
        type: String,
        default: "success" // Options: "success", "error", "info", "warning"
      }
    },
    data() {
      return {
        visible: true
      };
    },
    computed: {
      toastTypeClasses() {
        return {
          "bg-green-500": this.type === "success",
          "bg-red-500": this.type === "error",
          "bg-blue-500": this.type === "info",
          "bg-yellow-500": this.type === "warning"
        };
      }
    },
    methods: {
      closeToast() {
        this.visible = false;
      }
    }
  };
  </script>
  